/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateRunClubEventDistanceDto
 */
export interface UpdateRunClubEventDistanceDto {
    /**
     * Existing distance ID (for updates/deletes)
     * @type {string}
     * @memberof UpdateRunClubEventDistanceDto
     */
    'id'?: string;
    /**
     * If true and id provided, the distance will be soft-deleted
     * @type {boolean}
     * @memberof UpdateRunClubEventDistanceDto
     */
    'isDeleted'?: boolean;
    /**
     * Distance value
     * @type {number}
     * @memberof UpdateRunClubEventDistanceDto
     */
    'distanceValue'?: number;
    /**
     * Distance unit
     * @type {string}
     * @memberof UpdateRunClubEventDistanceDto
     */
    'distanceUnit'?: UpdateRunClubEventDistanceDtoDistanceUnitEnum;
    /**
     * Optional label
     * @type {string}
     * @memberof UpdateRunClubEventDistanceDto
     */
    'label'?: string;
}

export const UpdateRunClubEventDistanceDtoDistanceUnitEnum = {
    Km: 'km',
    Mi: 'mi'
} as const;

export type UpdateRunClubEventDistanceDtoDistanceUnitEnum = typeof UpdateRunClubEventDistanceDtoDistanceUnitEnum[keyof typeof UpdateRunClubEventDistanceDtoDistanceUnitEnum];


